import twitter from "../../assets/twitter.png";
import telegram from "../../assets/telegram.svg";
import discord from "../../assets/discord.png";
import linkedln from "../../assets/linkedin.png";
import facebook from "../../assets/Facebook.png";
import instagram from "../../assets/instagram.png";
import reddit from "../../assets/reddit.png";
import gate from "../../assets/gate.png";
import medium from "../../assets/medium.png";
import youtube from "../../assets/youtube.png";
import gold from "../../assets/gold.png";
import silver from "../../assets/silver.png";
import bronze from "../../assets/bronze.png";
const OTE = [
    { name: "Follow Brú on Twitter", xp: "10" },
    { name: "Follow Brú Finance CEO’s Twitter Account", xp: "10" },
    { name: "Follow Brú on Telegram", xp: "10" },
    { name: "Follow Brú on Discord", xp: "10" },
    { name: "Subscribe to Bru’s YouTube Channel", xp: "10" },
];
const DAILY = [
    { name: "Like, Comment & Retweet Twitter posts", xp: "10" },
    { name: "Like, Comment & Retweet Linkedln posts", xp: "10" },
    { name: "Like, Comment & Retweet Facebook posts", xp: "10" },
    { name: "Engagement on Discord", xp: "10" },
    { name: "Engagement on Telegram", xp: "10" },
];
const POW = [
    { name: "Make a YouTube Video on Brú Finance", xp: "10" },
    { name: "Write a Medium Blog for Brú Finance", xp: "10" },
    { name: "Write a review about Brú Finance App", xp: "10" },
    { name: "Create Infographic Design", xp: "10" },
    { name: "Create a meme for Brú Finance", xp: "10" },
];
const SOCIAL = [
    { img: twitter, link: "https://twitter.com/bru_finance" },
    { img: telegram, link: "https://t.me/bruofficial" },
    { img: discord, link: "https://discord.gg/8C9SZXDy2r" },
    { img: linkedln, link: "https://www.linkedin.com/company/bru-finance/" },
    { img: facebook, link: "https://www.facebook.com/brufinance/" },
    {
        img: instagram,
        link: "https://www.instagram.com/brufinance/?igshid=YmMyMTA2M2Y%3D",
    },
    { img: reddit, link: "https://www.reddit.com/user/Bru_Finance" },
    { img: gate, link: "https://warpcast.com/brufinance" },
    { img: medium, link: "https://medium.com/bru-finance" },
    { img: youtube, link: "https://www.youtube.com/@brufintech" },
];
const LEADERBOARD = [
    { userName: "SkyWalker_92", XP: "3000 XP", img: gold },
    { userName: "PixelPirate77", XP: "2780 XP", img: silver },
    { userName: "Quantum_Leap33", XP: "2680 XP", img: bronze },
    { userName: "Velvet_Vortex71", XP: "2500 XP" },
    { userName: "Turbo_Tiger09", XP: "2400 XP" },
    { userName: "Phantom_Panda34", XP: "2300 XP" },
    { userName: "Thunder_Wolf73", XP: "2280 XP" },
    { userName: "Vortex_Viper21", XP: "2270 XP" },
    { userName: "LedgerLynx", XP: "2250 XP" },
    { userName: "CryptoCrusader", XP: "2240 XP" },
    { userName: "DecentralDynamo", XP: "2240 XP" },
    { userName: "CryptoCatalyst", XP: "2200 XP" },
    { userName: "TokenTitan", XP: "2150 XP" },
    { userName: "BitBlaze", XP: "2000 XP" },
];
const QUESTIONS = [
    {
        question: "How do I join the Bru Finance Points Program?",
        answer: "Simply sign up on the Zealy platform and start completing Quests to earn points.",
    },
    {
        question: "Can I participate in multiple Quests?",
        answer: "You can participate in as many Quests as possible to maximize your points.  ",
    },
    {
        question: "How are points calculated?",
        answer: "Points are awarded based on the completion of Quests on the Zealy platform.",
    },
    {
        question: "How to view leaderboard ranking?",
        answer: "Make sure to connect the same wallet that has been connected on Zealy to view the Leaderboard Rank  ",
    },
    {
        question: "Want to give any feedback or want to contact us?  ",
        answer: "In case of any issues regarding the program reach out to Admins on telegram or reach out to hello@bru.finance",
    },
];
export default { OTE, DAILY, POW, SOCIAL, LEADERBOARD, QUESTIONS };
